<div class="d-flex">
  <aside class="sidebar" [ngClass]="{ 'sidebar-expanded': !collapsed }" data-automation="auto-attendants-sidebar">
    <div
      class="d-flex align-items-center"
      [ngClass]="{ 'sidebar-expanded__toggle': !collapsed, sidebar__toggle: collapsed }"
    >
      @if (!collapsed) {
        <h5 class="strong">{{ 'tkey;migrations.cisco.auto_attendants_details.sidebar.title' | translate }}</h5>
      }
      <button
        data-automation="auto-attendants-sidebar-toggle-btn"
        #sidebarTooltip="ngbTooltip"
        (click)="toggleSidebar(); sidebarTooltip.close()"
        class="sidebar__toggle-btn"
        [disableTooltip]="!collapsed"
        [ngbTooltip]="'tkey;migrations.cisco.auto_attendants_details.sidebar.toggle' | translate"
        [container]="'body'"
        [placement]="'right'"
      >
        <i [class]="collapsed ? ziroIcons.NEXT : ziroIcons.PREVIOUS"></i>
      </button>
    </div>

    @if (!collapsed) {
      <button class="btn btn-border btn-sm btn-default mb-1" (click)="backToList()">
        <i [class]="ziroIcons.BACK_CIRCLE"></i>
        {{ 'tkey;migrations.cisco.auto_attendants_details.sidebar.back' | translate }}
      </button>
      <div class="sidebar-expanded__items-container" data-automation="auto-attendants-sidebar-items">
        @for (callHandler of callHandlers; track callHandler.id) {
          <div
            (click)="navigateToHandler(callHandler.id)"
            [attr.data-automation]="'sidebar-' + callHandler.id"
            class="sidebar-expanded__item mb-1"
            [ngClass]="{ 'sidebar-expanded__item--active': callHandler.id === currentCallHandlerId }"
          >
            <span class="strong">{{ callHandler.displayName }}</span>
            <span class="sidebar-expanded__item-sub text-muted">
              {{ 'tkey;migrations.cisco.auto_attendants_details.sidebar.item.number' | translate }}
              @if (callHandler.extension) {
                <span>{{ callHandler.extension }}</span>
              } @else {
                <i>
                  {{ 'tkey;migrations.cisco.auto_attendants_details.sidebar.item.number.not_configured' | translate }}
                </i>
              }
            </span>
          </div>
        }
      </div>
    }
  </aside>

  <main class="content container" [ngClass]="{ 'content-expanded': !collapsed }">
    <ziro-breadcrumbs>
      <ziro-breadcrumb-card-item [aboutCardId]="114"></ziro-breadcrumb-card-item>
    </ziro-breadcrumbs>

    @if (chartLoading) {
      <ziro-loading-block></ziro-loading-block>
    } @else {
      <div
        class="alert alert-info"
        data-automation="auto-attendants-timezone"
        [innerHTML]="
          (timezone
            ? 'tkey;migrations.cisco.auto_attendants_report.explorer.timezone'
            : 'tkey;migrations.cisco.auto_attendants_report.explorer.timezone_none'
          ) | escapeHtml: { timezone: timezone }
        "
      ></div>

      @if (autoAttendantsReport) {
        <ziro-migrations-cisco-auto-attendants-explorer
          data-automation="auto-attendants-explorer"
          class="w-100"
          [autoAttendantsReport]="autoAttendantsReport"
          [directoryNumbersReport]="directoryNumbersReport"
          [activeGreetingAudioUrl]="activeGreetingAudioUrl"
          [activeGreetingAudioLoadingUrl]="activeGreetingAudioLoadingUrl"
          [activeGreetingAudioDownloadUrl]="activeGreetingAudioDownloadUrl"
          (playGreetingAudio)="playGreetingAudio($event)"
          (stopGreetingAudio)="onStopRequested()"
          (downloadGreetingAudio)="downloadGreetingAudio($event)"
        ></ziro-migrations-cisco-auto-attendants-explorer>
      }
    }
  </main>
</div>
